import * as z from "zod/v4";

const LinearProjectSchema_ = z.object({ id: z.string(), name: z.string() });

export const LinearProjectSchema: z.ZodType<LinearProject> =
  LinearProjectSchema_;
export interface LinearProject extends z.infer<typeof LinearProjectSchema_> {}

export const getLinearProjects = {
  name: "getLinearProjects" as const,
  input: z.object({}),
  output: z.object({ projects: z.array(LinearProjectSchema) }),
};
